module.exports = __webpack_public_path__ + "img/9788949120614.5b05cffd.jpg";